import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.reflect.construct.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withRouter } from 'react-router';
import i18n from 'i18next';
import styled from 'styled-components';
import Landmark from 'components/Landmark';
import log from 'utils/log';
var Details = styled.details.withConfig({
  displayName: "ErrorBoundary__Details",
  componentId: "sc-149b6vs-0"
})(["max-height:200px;margin-top:0.5rem;overflow:auto;font-size:0.8em;white-space:pre-wrap;"]);
var INIITIAL_STATE = {
  error: null,
  errorInfo: null
};
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = INIITIAL_STATE;
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      log({
        message: "Error in ErrorBoundary: ".concat(error.toString()),
        metadata: {
          error: error.toString(),
          errorInfo: errorInfo
        }
      });
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Reset error boundary on navigation
      // Note that query parameter changes don't reset the error boundary.
      var hasPathnameChanged = prevProps.location.pathname !== this.props.location.pathname;
      if (this.state.error && hasPathnameChanged) {
        this.setState(INIITIAL_STATE);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        renderCustomError = _this$props.renderCustomError;
      var _this$state = this.state,
        error = _this$state.error,
        errorInfo = _this$state.errorInfo;
      var customError = error && (renderCustomError === null || renderCustomError === void 0 ? void 0 : renderCustomError(error));
      if (customError) {
        return customError;
      } else if (errorInfo) {
        return /*#__PURE__*/React.createElement(Landmark, {
          icon: "flag"
        }, /*#__PURE__*/React.createElement("p", null, i18n.t('error_whoops_there_has_been_an_error')), /*#__PURE__*/React.createElement("p", null, i18n.t('error_bug_contact_admin')), /*#__PURE__*/React.createElement(Details, null, /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement("b", null, i18n.t('error_details'))), error === null || error === void 0 ? void 0 : error.toString(), /*#__PURE__*/React.createElement("br", null), errorInfo.componentStack));
      }
      return children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);
export default withRouter(ErrorBoundary);